import { Fragment } from 'react'

import { parseCommentSegments } from './utils/parseCommentSegments'

export interface ICommentBodyProps {
  comment: string
}

// React escapes text children, so untrusted content cannot become markup.
export const CommentBody = ({ comment }: ICommentBodyProps) => (
  <span>
    {parseCommentSegments(comment).map((segment) => {
      if (segment.type === 'mention') {
        return (
          <span className='mention' key={`mention-${segment.start}`}>
            {segment.text}
          </span>
        )
      }

      return <Fragment key={`text-${segment.start}`}>{segment.text}</Fragment>
    })}
  </span>
)

CommentBody.displayName = 'CommentBody'
